/**
 * 获取 axios 的错误信息
 * @param err axios 错误对象
 * @returns {string|*}
 */
export const getAxiosError = err => {
  if (err.response) {
    return err.response.data || `${err.response.status} ${err.response.statusText}`;
  } else {
    return err.message;
  }
};
